import { paramsToQueryString } from '@/shared/lib/util';
import axios from 'axios';
import { saveAs } from 'file-saver';
import ApiMethods from 'shared/api/api-methods';
import { getAccessToken } from 'shared/lib/sessionTokenAccessor';
import type { Directory, PatchProps } from 'shared/types/file-storage-types';

const url = '/file-storage';

export function requestFiles(
  directory: Directory,
  folderPath: string,
  slug: string
) {
  return ApiMethods.post(`${url}/${slug}/files`, { directory, folderPath });
}

export function patchFiles(slug: string, data: PatchProps) {
  return ApiMethods.patch(`${url}/userdata/${slug}`, data);
}

export async function getDownloadToken(slug: string) {
  return ApiMethods.get(`${url}/userdata/${slug}/download_token`);
}

function downloadFiles({
  token,
  directory,
  filename,
  path,
}: {
  token: string;
  directory: string;
  filename: string;
  path?: string;
}) {
  const params = {
    token,
    directory,
    path,
  };

  fetch(
    `${process.env.API_URL}${url}/userdata/download${paramsToQueryString(params)}`
  )
    .then((response) => response.blob())
    .then((blob) => {
      saveAs(blob, filename);
    })
    .catch(() => {});
}

export async function download({
  slug,
  item,
  path,
  filename,
}: {
  slug: string;
  item: string;
  filename: string;
  path?: string;
}) {
  return getDownloadToken(slug)
    .then((response) =>
      response.ok ? response.json() : Promise.reject(response)
    )
    .then((data) => {
      const directory = item;
      // console.log(directory);

      downloadFiles({ token: data?.token, directory, filename, path });
    })
    .catch((e) => console.log(e));
}

export async function upload(
  formData: FormData,
  uploadEndpoint: string,
  setProgress: (percent: number) => void
) {
  const accessToken = await getAccessToken();
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };

  const res = await axios.post(uploadEndpoint, formData, {
    headers,
    onUploadProgress: (progressEvent) => {
      if (progressEvent.lengthComputable && progressEvent.total) {
        const percent = Math.round(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        setProgress(percent);
      }
    },
  });

  return res;
}
